import { render } from "./Group_steps.vue?vue&type=template&id=6b5531ee&scoped=true"
import script from "./Group_steps.vue?vue&type=script&lang=js"
export * from "./Group_steps.vue?vue&type=script&lang=js"

import "./Group_steps.vue?vue&type=style&index=0&id=6b5531ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5531ee"]])

export default __exports__